import { Link } from 'react-router-dom';
import { getAssetsFileUrl } from '~/utils/assetsHelper';
import './authlayout.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
function AuthenticationLayout({ children }) {
    const logo = getAssetsFileUrl('logo', 'app-logo.png');
    return (
        <main className='main'>
            <div className='container'>
                <div className='row flex-center auth-wrapper py-5'>
                    <div className='col-sm-10 col-md-8 col-lg-5 col-xl-5 col-xxl-4 bg-white p-4 p-sm-5 rounded-4 shadow-sm border border-1 border-light z-1'>
                        <Link className="d-flex flex-center text-decoration-none mb-2" to="/home">
                            <div className="d-flex align-items-center fw-bolder fs-3 d-inline-block">
                                {
                                    logo &&
                                    <img src={logo} alt="breakthrough" width="58" />
                                }
                            </div>
                        </Link>
                        {children}
                        <div className="text-center">
                            <Link to="/" className="auth-back-link">
                                <FontAwesomeIcon icon={faArrowLeft} />
                                Back to home page
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <footer className='text-center'>
                <span className="fs-9 pe-4 text-body-tertiary">©{new Date().getFullYear()} BreakThrough, Inc. All rights reserved.</span>
                <Link className="fs-9 fw-semibold pe-4 text-decoration-none" to="/home">Terms of use</Link>
                <Link className="fs-9 fw-semibold text-decoration-none" to="/home">Privacy policy</Link>
            </footer>
        </main>
    )
}
export default AuthenticationLayout;